/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.BusinessTypes {
    "use strict";

    export class BusinessTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public filter: string;
      
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService) {
                super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
                this.baseEndpoint = this.appSettings.API_ENDPOINTS.businessTypes;
                this.sectionTemplatePath = "app/plugins/businessTypes/sectionViews/";
                this.buildCrudSecurityKeys(this.securityKeys.DATA_BUSINESSTYPE_TAB_MAIN);
                this.entityType = 'BusTypes';
            }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_BUSINESSTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "Main", "main.html", true, false, this.appSettings.API_ENDPOINTS.businessTypes, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.BusinessType, null, this.securityKeys.DATA_BUSINESSTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            //this.businessTypeDetail = model.businessTypeDetail;
        }

        get canCoCopy(): boolean {
            return true;
        }
    }
}